import React from 'react';
import Layout from '../components/layout/Layout';
import SEO from '../components/SEO';
import { Link } from 'react-router-dom';
import { ShieldCheck, Eye, Lock, Share2, Cookie, RefreshCw, Mail } from 'lucide-react';

const sections = [
  {
    icon: Eye,
    title: 'Collecte et Utilisation des Informations',
    content: "Lorsque vous visitez notre site web, nous pouvons collecter certaines informations personnelles vous concernant, telles que votre nom, votre adresse e-mail et d'autres données similaires que vous choisissez de nous fournir volontairement. Nous utilisons ces informations dans le seul but de répondre à vos demandes, de vous fournir des services personnalisés et de vous tenir informé(e) de nos produits, promotions ou événements spéciaux, si vous avez consenti à recevoir de telles communications.",
  },
  {
    icon: Lock,
    title: 'Protection de vos Données',
    content: "Nous nous engageons à protéger vos données personnelles et à les traiter de manière confidentielle. Nous mettons en oeuvre des mesures de sécurité appropriées pour protéger vos informations contre tout accès non autorisé, toute divulgation, toute altération ou toute destruction non autorisée.",
  },
  {
    icon: Share2,
    title: 'Partage des Informations',
    content: "Nous ne vendons, ne louons ni ne partageons vos informations personnelles avec des tiers sans votre consentement explicite, sauf si cela est nécessaire pour répondre à vos demandes, pour fournir nos services ou si nous y sommes contraints par la loi.",
  },
  {
    icon: Cookie,
    title: 'Cookies',
    content: "Notre site web utilise des cookies pour améliorer votre expérience utilisateur. Ces cookies sont de petits fichiers texte placés sur votre appareil pour collecter des informations standard de journal Internet et de comportement des visiteurs de manière anonyme. Vous pouvez modifier les paramètres de votre navigateur pour désactiver les cookies, mais veuillez noter que certaines fonctionnalités de notre site pourraient ne pas fonctionner correctement sans eux.",
  },
  {
    icon: RefreshCw,
    title: 'Modifications de la Politique de Confidentialité',
    content: "Nous nous réservons le droit de modifier cette politique de confidentialité à tout moment, sans préavis. Les modifications apportées à cette politique seront publiées sur cette page, et la date de révision la plus récente sera indiquée en haut de la page. Nous vous encourageons à consulter régulièrement cette politique pour rester informé(e) de la manière dont nous protégeons vos informations.",
  },
];

const PolitiqueConfidentialitePage = () => {
  return (
    <Layout>
      <SEO title="Politique de Confidentialité — RGPD" description="Politique de confidentialité SOGNUDIMARE — protection des données personnelles, RGPD, cookies, droits des utilisateurs." path="/politique-de-confidentialite" />
      {/* Hero */}
      <section className="relative pt-32 pb-16 bg-[#1D3557]" data-testid="politique-confidentialite-hero">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 rounded-full mb-6">
            <ShieldCheck className="h-4 w-4 text-[#2A9D8F]" />
            <span className="text-white/80 text-sm">Vos données protégées</span>
          </div>
          <h1 className="text-4xl sm:text-5xl font-bold text-white mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
            Politique de Confidentialité
          </h1>
          <p className="text-white/70 text-lg max-w-2xl mx-auto">
            Chez sognudimare, nous accordons une importance capitale à la protection de vos données personnelles. Cette politique vous informe sur la manière dont nous collectons, utilisons et protégeons vos informations.
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 bg-white" data-testid="politique-confidentialite-content">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid gap-8">
            {sections.map((section, index) => (
              <div key={index} className="bg-slate-50 rounded-2xl p-8 border border-slate-100">
                <div className="flex items-center gap-3 mb-6">
                  <div className="p-2.5 bg-[#2A9D8F]/10 rounded-xl">
                    <section.icon className="h-6 w-6 text-[#2A9D8F]" />
                  </div>
                  <h2 className="text-2xl font-bold text-[#1D3557]" style={{ fontFamily: "'Playfair Display', serif" }}>
                    {section.title}
                  </h2>
                </div>
                <p className="text-slate-600 leading-relaxed">
                  {section.content}
                </p>
              </div>
            ))}

            {/* Contact CTA */}
            <div className="bg-[#1D3557] rounded-2xl p-8 text-center">
              <h3 className="text-xl font-bold text-white mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>
                Contactez-nous
              </h3>
              <p className="text-white/70 mb-6">
                Si vous avez des questions ou des préoccupations concernant notre politique de confidentialité, ou si vous souhaitez exercer vos droits en matière de protection des données, n'hésitez pas à nous contacter.
              </p>
              <Link
                to="/contact"
                className="inline-flex items-center gap-2 px-8 py-4 bg-[#2A9D8F] text-white font-semibold rounded-xl hover:bg-[#238577] transition-colors"
                data-testid="politique-contact-btn"
              >
                <Mail className="h-5 w-5" />
                Nous contacter
              </Link>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default PolitiqueConfidentialitePage;
